import { useHpaV2MigrationEligibilityQuery } from 'hooks/queries/workload-optimization/useHpaV2MigrationEligibilityQuery';

import { useHpaV2Status } from './useHpaV2Status';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useCanMigrateHpaV2 = () => {
  const { cluster } = useCluster();

  const { hpaV2Status } = useHpaV2Status();

  const { data: eligibilityData } = useHpaV2MigrationEligibilityQuery({
    clusterId: cluster.id,
    enabled: hpaV2Status === 'available',
  });

  return {
    canMigrateHpaV2:
      hpaV2Status === 'available' &&
      !!eligibilityData?.eligibleCount &&
      eligibilityData.eligibleCount > 0,
    hpaV2EligibleCount: eligibilityData?.eligibleCount ?? 0,
  };
};
